export default "__VITE_ASSET__26xhvcGI__"